import type { GroundControlLocation, Inspection, Concern } from '../types';

// Realistic Cory Mine (Nutrien) potash mine locations
export const SEED_LOCATIONS: Omit<GroundControlLocation, 'id'>[] = [
  {
    Area: 'Room 1 North',
    AreaType: 'Underground',
    Enabled: true,
    LastInspectedDate: '2025-04-10',
    NumberOfConcerns: 2,
    AllRedTaped: 'Yes',
    InspectedBy: 'John Mitchell',
    GroundMatrixScore: 72,
    NextInspectionDueBy: '2025-07-10',
    Comment: 'Minor scaling observed on east wall. Bolts checked.',
  },
  {
    Area: 'Room 2 South',
    AreaType: 'Underground',
    Enabled: true,
    LastInspectedDate: '2025-03-28',
    NumberOfConcerns: 0,
    AllRedTaped: 'N/A',
    InspectedBy: 'Sarah Peters',
    GroundMatrixScore: 85,
    NextInspectionDueBy: '2025-06-28',
    Comment: '',
  },
  {
    Area: 'Ramp Access North',
    AreaType: 'Underground',
    Enabled: true,
    LastInspectedDate: '2025-04-18',
    NumberOfConcerns: 1,
    AllRedTaped: 'Yes',
    InspectedBy: 'Dave Thompson',
    GroundMatrixScore: 55,
    NextInspectionDueBy: '2025-10-18',
    Comment: 'Water seepage noted near chainage 420m. Drains functional.',
  },
  {
    Area: 'Shaft Station 1',
    AreaType: 'Shaft',
    Enabled: true,
    LastInspectedDate: '2025-04-22',
    NumberOfConcerns: 0,
    AllRedTaped: 'N/A',
    InspectedBy: 'Lisa Anderson',
    GroundMatrixScore: 91,
    NextInspectionDueBy: '2025-07-22',
    Comment: 'All clear. Guides and buntons in good condition.',
  },
  {
    Area: 'Shaft Station 2',
    AreaType: 'Shaft',
    Enabled: true,
    LastInspectedDate: '2025-02-15',
    NumberOfConcerns: 3,
    AllRedTaped: 'No',
    InspectedBy: 'John Mitchell',
    GroundMatrixScore: 44,
    NextInspectionDueBy: '2025-08-15',
    Comment: 'Multiple cracks identified. Engineering review pending.',
  },
  {
    Area: 'Processing Plant Level 2',
    AreaType: 'Processing',
    Enabled: true,
    LastInspectedDate: '2025-04-01',
    NumberOfConcerns: 1,
    AllRedTaped: 'Yes',
    InspectedBy: 'Sarah Peters',
    GroundMatrixScore: 68,
    NextInspectionDueBy: '2025-07-01',
    Comment: 'Spalling on pillar P-7. Monitored.',
  },
  {
    Area: 'Warehouse Loading Dock',
    AreaType: 'Surface',
    Enabled: true,
    LastInspectedDate: '2025-04-25',
    NumberOfConcerns: 0,
    AllRedTaped: 'N/A',
    InspectedBy: 'Dave Thompson',
    GroundMatrixScore: 88,
    NextInspectionDueBy: '2025-07-25',
    Comment: '',
  },
  {
    Area: 'Maintenance Bay A',
    AreaType: 'Infrastructure',
    Enabled: true,
    LastInspectedDate: '2025-03-12',
    NumberOfConcerns: 2,
    AllRedTaped: 'Yes',
    InspectedBy: 'Lisa Anderson',
    GroundMatrixScore: 60,
    NextInspectionDueBy: '2025-06-12',
    Comment: 'Roof panel loose near bay door. Secured temporarily.',
  },
  {
    Area: 'Pump Station East',
    AreaType: 'Underground',
    Enabled: true,
    LastInspectedDate: '2025-04-08',
    NumberOfConcerns: 0,
    AllRedTaped: 'N/A',
    InspectedBy: 'John Mitchell',
    GroundMatrixScore: 79,
    NextInspectionDueBy: '2025-07-08',
    Comment: 'Pumps operational. Ground conditions stable.',
  },
  {
    Area: 'Emergency Exit B',
    AreaType: 'Underground',
    Enabled: true,
    LastInspectedDate: '2025-01-30',
    NumberOfConcerns: 0,
    AllRedTaped: 'N/A',
    InspectedBy: 'Sarah Peters',
    GroundMatrixScore: 52,
    NextInspectionDueBy: '2025-07-30',
    Comment: '',
  },
];

// Sample inspection records (last 60 days)
export const SEED_INSPECTIONS: Omit<Inspection, 'id'>[] = [
  {
    Area: 'Room 1 North',
    AreaType: 'Underground',
    DateInspected: '2025-04-10',
    InspectedBy: 'John Mitchell',
    Supervisor: 'Mike Wilson',
    RedTaped: 'Yes',
    HighbackInspected: 'Yes',
    NumberOfConcerns: 2,
    Comment: 'Minor scaling observed on east wall.',
    Year: 2025,
    Period: 'Q2',
  },
  {
    Area: 'Room 2 South',
    AreaType: 'Underground',
    DateInspected: '2025-03-28',
    InspectedBy: 'Sarah Peters',
    Supervisor: 'Karen Stevens',
    RedTaped: 'N/A',
    HighbackInspected: 'Yes',
    NumberOfConcerns: 0,
    Comment: '',
    Year: 2025,
    Period: 'Q1',
  },
  {
    Area: 'Ramp Access North',
    AreaType: 'Underground',
    DateInspected: '2025-04-18',
    InspectedBy: 'Dave Thompson',
    Supervisor: 'Mike Wilson',
    RedTaped: 'Yes',
    HighbackInspected: 'Yes',
    NumberOfConcerns: 1,
    Comment: 'Water seepage noted near chainage 420m.',
    Year: 2025,
    Period: 'Q2',
  },
  {
    Area: 'Shaft Station 1',
    AreaType: 'Shaft',
    DateInspected: '2025-04-22',
    InspectedBy: 'Lisa Anderson',
    Supervisor: 'Karen Stevens',
    RedTaped: 'N/A',
    HighbackInspected: 'N/A',
    NumberOfConcerns: 0,
    Comment: 'All clear.',
    Year: 2025,
    Period: 'Q2',
  },
  {
    Area: 'Shaft Station 2',
    AreaType: 'Shaft',
    DateInspected: '2025-04-28',
    InspectedBy: 'John Mitchell',
    Supervisor: 'Mike Wilson',
    RedTaped: 'No',
    HighbackInspected: 'Yes',
    NumberOfConcerns: 3,
    Comment: 'Multiple cracks. Engineering review scheduled.',
    Year: 2025,
    Period: 'Q2',
  },
  {
    Area: 'Processing Plant Level 2',
    AreaType: 'Processing',
    DateInspected: '2025-04-01',
    InspectedBy: 'Sarah Peters',
    Supervisor: 'Karen Stevens',
    RedTaped: 'Yes',
    HighbackInspected: 'Yes',
    NumberOfConcerns: 1,
    Comment: 'Spalling on pillar P-7.',
    Year: 2025,
    Period: 'Q2',
  },
  {
    Area: 'Maintenance Bay A',
    AreaType: 'Infrastructure',
    DateInspected: '2025-04-30',
    InspectedBy: 'Lisa Anderson',
    Supervisor: 'Mike Wilson',
    RedTaped: 'Yes',
    HighbackInspected: 'No',
    NumberOfConcerns: 2,
    Comment: 'Roof panel near bay door secured temporarily.',
    Year: 2025,
    Period: 'Q2',
  },
  {
    Area: 'Warehouse Loading Dock',
    AreaType: 'Surface',
    DateInspected: '2025-04-25',
    InspectedBy: 'Dave Thompson',
    Supervisor: 'Karen Stevens',
    RedTaped: 'N/A',
    HighbackInspected: 'N/A',
    NumberOfConcerns: 0,
    Comment: '',
    Year: 2025,
    Period: 'Q2',
  },
];

// Sample concerns
export const SEED_CONCERNS: Omit<Concern, 'id'>[] = [
  {
    Area: 'Room 1 North',
    AreaType: 'Underground',
    Deficiency: 'Loose rock / scaling required',
    RemedialAction: 'Scale and re-support',
    SpadBT: 'BT-2025-041',
    Remediated: 'No',
    Comment: 'Scaling required on east wall section',
    Inspector: 'John Mitchell',
    Supervisor: 'Mike Wilson',
    InspectionDate: '2025-04-10',
    Status: 'Open',
  },
  {
    Area: 'Room 1 North',
    AreaType: 'Underground',
    Deficiency: 'Missing or inadequate bolts',
    RemedialAction: 'Install additional rock bolts',
    SpadBT: 'BT-2025-042',
    Remediated: 'Yes',
    RemediatedDate: '2025-04-12',
    Comment: 'Two bolts replaced at row 14',
    Inspector: 'John Mitchell',
    Supervisor: 'Mike Wilson',
    InspectionDate: '2025-04-10',
    Status: 'Closed',
  },
  {
    Area: 'Ramp Access North',
    AreaType: 'Underground',
    Deficiency: 'Water ingress / seepage',
    RemedialAction: 'Install drainage / dewater',
    SpadBT: 'BT-2025-043',
    Remediated: 'No',
    Comment: 'Seepage at chainage 420m, drain installed but monitoring required',
    Inspector: 'Dave Thompson',
    Supervisor: 'Mike Wilson',
    InspectionDate: '2025-04-18',
    Status: 'Open',
  },
  {
    Area: 'Shaft Station 2',
    AreaType: 'Shaft',
    Deficiency: 'Cracking / fracturing',
    RemedialAction: 'Engineering assessment required',
    SpadBT: 'BT-2025-044',
    Remediated: 'No',
    Comment: 'Horizontal crack at +220m elevation',
    Inspector: 'John Mitchell',
    Supervisor: 'Mike Wilson',
    InspectionDate: '2025-04-28',
    Status: 'Open',
  },
  {
    Area: 'Shaft Station 2',
    AreaType: 'Shaft',
    Deficiency: 'Inadequate support',
    RemedialAction: 'Install additional rock bolts',
    SpadBT: 'BT-2025-045',
    Remediated: 'No',
    Comment: 'Support density below standard in NW quadrant',
    Inspector: 'John Mitchell',
    Supervisor: 'Mike Wilson',
    InspectionDate: '2025-04-28',
    Status: 'Open',
  },
  {
    Area: 'Shaft Station 2',
    AreaType: 'Shaft',
    Deficiency: 'Damaged mesh / screen',
    RemedialAction: 'Install mesh / screen',
    SpadBT: 'BT-2025-046',
    Remediated: 'No',
    Comment: 'Screen torn at +215m elevation, south side',
    Inspector: 'John Mitchell',
    Supervisor: 'Mike Wilson',
    InspectionDate: '2025-04-28',
    Status: 'Open',
  },
  {
    Area: 'Processing Plant Level 2',
    AreaType: 'Processing',
    Deficiency: 'Rib spalling',
    RemedialAction: 'Apply shotcrete',
    SpadBT: 'BT-2025-047',
    Remediated: 'No',
    Comment: 'Spalling on pillar P-7 west face',
    Inspector: 'Sarah Peters',
    Supervisor: 'Karen Stevens',
    InspectionDate: '2025-04-01',
    Status: 'Open',
  },
  {
    Area: 'Maintenance Bay A',
    AreaType: 'Infrastructure',
    Deficiency: 'Unsupported back span',
    RemedialAction: 'Red tape / barricade area',
    SpadBT: 'BT-2025-048',
    Remediated: 'Yes',
    RemediatedDate: '2025-05-01',
    Comment: 'Area barricaded pending permanent repair',
    Inspector: 'Lisa Anderson',
    Supervisor: 'Mike Wilson',
    InspectionDate: '2025-04-30',
    Status: 'Closed',
  },
  {
    Area: 'Maintenance Bay A',
    AreaType: 'Infrastructure',
    Deficiency: 'Loose rock / scaling required',
    RemedialAction: 'Scale and re-support',
    SpadBT: 'BT-2025-049',
    Remediated: 'No',
    Comment: 'Section above bay door 3 requires scaling',
    Inspector: 'Lisa Anderson',
    Supervisor: 'Mike Wilson',
    InspectionDate: '2025-04-30',
    Status: 'Open',
  },
];
